<div class="container" style="padding-left: 20px; padding-right: 20px; height: 1200px">
  <button (click)="exportHtml()">Export</button>
  <email-editor [minHeight]="'700px'" (loaded)="editorLoaded()"></email-editor>
</div>
